import React from "react";
import { Link as MLink } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
interface Props {
  to: string;
  target?: string;
}
const Link: React.FC<Props> = ({ children, to, target }) => {
  return (
    <MLink component={RouterLink} to={to} target={target}>
      {children}
    </MLink>
  );
};

export default Link;
